import { Modal as TwsModal, Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IApplicationState } from '../../../store';
import { DistributionHelper } from '../../../utilities/DistributionHelper';
import { WarningModalBody, WarningModalHeadline } from '../../common/styles/globalStyles';

const Modal = styled(TwsModal)`
	.modal-content {
		height: auto;
		min-height: 500px;
		text-align: center;
	}

	& .tws-button-group {
		align-items: start;
	}
`;
Modal.displayName = 'Modal';

const AccessCodeModalBody = styled(WarningModalBody)`
	margin-bottom: 20px;
`;
Modal.displayName = 'Modal';

export interface IDistributionOptionDataTransferModalProps {
	modalOpen: boolean;
	closeModal: () => any;
	onSubmit: (transfer: boolean) => any;
}

export const DistributionOptionDataTransferModal = (props: IDistributionOptionDataTransferModalProps) => {
	const { closeModal, modalOpen, onSubmit } = props;

	const { invitationEmail } = useSelector((storeState: IApplicationState) => storeState.emailTemplates);
	const hasAccessCode = DistributionHelper.hasAccessCode(invitationEmail.content);

	return (
		<>
			<Modal
				isOpen={modalOpen}
				title={ContentConstants.DATA_TRANSFER}
				contenthcentered={true}
				contentvcentered={true}
				contentfullwidth={false}
				type={'lightbox'}
				primaryButtonText={ContentConstants.YES_TRANSFER_DATA}
				secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
				alternatePrimaryButtonText={ContentConstants.NO_TRANSFER_DATA}
				onClosed={closeModal}
				onAlternatePrimaryButtonClick={() => onSubmit(false)}
				onSubmit={() => onSubmit(true)}
			>
				<div>
					{hasAccessCode && (
						<AccessCodeModalBody>
							<Pullout type={PulloutType.Warning}>{ContentConstants.WARNING_DISTRIBUTION_ACCESSCODE_TRANSFER_BODY}</Pullout>
						</AccessCodeModalBody>
					)}
					<WarningModalHeadline>{ContentConstants.WARNING_DISTRIBUTION_DATA_TRANSFER_HEADLINE}</WarningModalHeadline>
					<WarningModalBody>{ContentConstants.WARNING_DISTRIBUTION_DATA_TRANSFER_BODY}</WarningModalBody>
				</div>
			</Modal>
		</>
	);
};
